import { render, staticRenderFns } from "./ReviewArea.vue?vue&type=template&id=9e098d86&scoped=true&"
import script from "./ReviewArea.vue?vue&type=script&lang=ts&"
export * from "./ReviewArea.vue?vue&type=script&lang=ts&"
import style0 from "./ReviewArea.vue?vue&type=style&index=0&id=9e098d86&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e098d86",
  null
  
)

export default component.exports